import { Box, Text, Link } from '@chakra-ui/react';
import Row from '@inspire/ui/chakra/layout/Row';
import LinkButton from 'components/general/LinkButton';
import {
  emphasisButtonProps,
  roundButtonProps,
} from '@inspire/ui/chakra/theme';
import { MENTIONS_LEGALES_PATH } from 'lib/paths';
import { accessSSO } from 'lib/sso';

const A1ConnectLandingPageFooter = ({ isMobile, inscriptionPath }) => {
  return isMobile ? (
    <Row
      bg="#111111"
      display="flex"
      flexDir="column"
      p={10}
      textAlign="center"
      alignItems="center"
    >
      <LinkButton
        href={inscriptionPath}
        {...roundButtonProps}
        {...emphasisButtonProps}
        onClick={() => {
          accessSSO({
            targetUrl: inscriptionPath,
          });
        }}
        p={8}
        width="100%"
      >
        <Text fontSize={['lg', 'lg', 'xl']} fontWeight="bold" letterSpacing={4}>
          <b>NOUS REJOINDRE</b>
        </Text>
      </LinkButton>
    </Row>
  ) : (
    <Row
      bg="white"
      display="flex"
      flexDir="row"
      textAlign="center"
      alignItems="center"
    >
      <Box width="50%" height="100%" textAlign="left">
        <Text ml="10" color="grey">
          UN PROJET PORTÉ PAR{' '}
          <Link color="grey" href="https://article-1.eu/">
            ARTICLE 1
          </Link>
        </Text>
      </Box>
      <Box
        width="50%"
        height="100%"
        display="flex"
        justifyContent="space-around"
      >
        <Text>
          <Link
            color="grey"
            textDecor="none"
            href="mailto:contact@inspire-orientation.org"
          >
            NOUS CONTACTER
          </Link>
        </Text>
        <Text>
          <Link
            color="grey"
            textDecor="none"
            href="https://connect.article-1.eu/legals/politique-confidentialite"
          >
            POLITIQUE DE CONFIDENTIALITÉ
          </Link>
        </Text>
        <Text>
          <Link color="grey" textDecor="none" href={MENTIONS_LEGALES_PATH}>
            MENTIONS LÉGALES
          </Link>
        </Text>
        <Text>
          <Link
            color="grey"
            textDecor="none"
            href="https://connect.article-1.eu/legals/conditions-generales"
          >
            CGU
          </Link>
        </Text>
      </Box>
    </Row>
  );
};

export default A1ConnectLandingPageFooter;
